export default {"src":"/_next/static/media/ONDO.ff377981.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};